export default __webpack_public_path__ + "static/media/check_circle-24px.1028bfd6.svg";